// extracted by mini-css-extract-plugin
module.exports = {"header-stats":"header-stats___2Cxd0","stat-box":"stat-box___1TxPy","stat-value":"stat-value___26cwE","stat-label":"stat-label___3pZ-f"};